module.exports = __webpack_public_path__ + "img/u3156.981da407.svg";